module.exports = __webpack_public_path__ + "media/images/homes/online_ordering-593467e0d34b2c160701461355ea1e98.png";